// https://stackoverflow.com/questions/1720320/how-to-dynamically-create-css-class-in-javascript-and-apply
const createCssClass = (className: string, styles: string) => {
    let style = document.createElement('style') as any as HTMLStyleElement;

    style.innerHTML = `.${className} ${styles}`;
    document.getElementsByTagName('head')[0].appendChild(style);
};

export { createCssClass };
